module.exports = __webpack_public_path__ + "static/media/desvincular.91af3919.svg";